export default "__VITE_ASSET__CUewYjqD__"